import React from 'react';
import './style.css';

function index() {
  return (
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  )
}

export default index
